import {
  Component, ElementRef,
  HostListener,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: "RadioSelect",
  templateUrl: './radioselect.component.html',
  styleUrls: ['./radioselect.component.scss'],
})
export class RadioSelect implements OnChanges  {

  @Input() icon: string;
  @Input() text: string;
  @Input() default: string;
  @Input() showSearch: boolean = true;
  @Input() items: any; // [{text: ..., value: ...}, ...s]
  @Input() placeholder: string = "Search..";
  @Input() onChange: any;
  public open: boolean = false;
  public search: string = "";
  public filteredItems: any[] = [];
  public selectedItem: string = "";
  public selectedValue: string = "";

  constructor(private eRef: ElementRef) {
    this.changeSelect = this.changeSelect.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if(!this.eRef.nativeElement.contains(event.target)) {
      this.open = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.items){
      this.filteredItems = this.filterByName(changes.items.currentValue, this.search);
    }
    if(changes.default && this.items){
      const item = this.items.filter(i => i.value === changes.default.currentValue);
      if (item.length === 1) {
        this.selectedItem = item[0].text;
      }
      this.selectedValue = changes.default.currentValue;
    }
  }

  filterByName(items, search){
    if(search == "") {
      return items;
    }
    return items.filter(i => i.text.includes(search) || i.text.toLowerCase().includes(search.toLowerCase()));
  }

  changeSearch(event) {
    const { value } = event.target;
    this.search = value;
    this.filteredItems = this.filterByName(this.items, this.search);
  }

  isSelected(value){
    return this.selectedValue === value;
  }

  changeSelect(value, event) {
    const item =  this.items.filter(i => i.value === value);
    if (item.length === 1) {
      this.selectedItem = item[0].text;
      this.selectedValue = value;
      this.onChange(this.selectedValue);
    }
  }

  toggleDropdown(){
    this.open = !this.open;
  }
}
